import React from 'react';
import EImg from './EImg';

export default ({ width = 24, height = 24 }) => (
	<EImg
		width={width}
		height={height}
		title="Fox"
		aria-label="Emoji: Fox"
		alt="🎩"
		src="https://abs.twimg.com/emoji/v2/svg/1f98a.svg"
	/>
);
